import { createClient } from '@supabase/supabase-js'
import { resolveSupabaseConfig } from './supabase-config'

const { url: supabaseUrl, key: supabasePublishableKey } = resolveSupabaseConfig(import.meta.env)

export const supabase = createClient(supabaseUrl, supabasePublishableKey)
